import React from "react";
import { useNavigate } from "react-router-dom";
import { IoCartOutline, IoConstructOutline } from "react-icons/io5";

const QuickNav = ({ visible = true }) => {
    const navigate = useNavigate();

    return (
        <div className={`sq-quick-nav-wrap ${visible ? "sq-quick-nav-show" : "sq-quick-nav-hide"}`}>
            <button
                type="button"
                className="sq-quick-nav-btn"
                onClick={() => navigate("/sifaris/shop-group")}
            >
                <div className="sq-quick-nav-icon">
                    <IoCartOutline size={18} color="#075E54" />
                </div>
                <span className="sq-quick-nav-text">Alqı-Satqı</span>
            </button>

            <button
                type="button"
                className="sq-quick-nav-btn"
                onClick={() => navigate("/sifaris/master")}
            >
                <div className="sq-quick-nav-icon">
                    <IoConstructOutline size={18} color="#075E54" />
                </div>
                <span className="sq-quick-nav-text">Ustalar</span>
            </button>
        </div>
    );
};

export default QuickNav;